import { render, staticRenderFns } from "./BaseMapNew.vue?vue&type=template&id=609fa54a&scoped=true&"
import script from "./BaseMapNew.vue?vue&type=script&lang=js&"
export * from "./BaseMapNew.vue?vue&type=script&lang=js&"
import style0 from "./BaseMapNew.vue?vue&type=style&index=0&id=609fa54a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609fa54a",
  null
  
)

export default component.exports